import { useEffect, useState, type ReactNode } from "react";

import { motion, useReducedMotion } from "framer-motion";

import {
  REVEAL_DURATION_MS,
  REVEAL_RISE_PX,
} from "@/blueprint/components/ScrollReveal/ScrollReveal";
import { MotionEasing } from "@/blueprint/tokens/Motion";

/**
 * [ScrollReveal]'s fade and rise, played on mount, for copy that starts in
 * view. Motion is assumed until the reduced-motion preference resolves after
 * mount; suppressing it until then would keep the entrance from ever playing.
 */
const MountReveal = ({
  delayMs = 0,
  className,
  children,
}: {
  delayMs?: number;
  className?: string | undefined;
  children: ReactNode;
}) => {
  const prefersReducedMotion = useReducedMotion() === true;
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  const reducedMotion = prefersReducedMotion && mounted;

  return (
    <motion.div
      {...(className !== undefined ? { className } : {})}
      initial={reducedMotion ? false : { opacity: 0, y: REVEAL_RISE_PX }}
      animate={{ opacity: 1, y: 0 }}
      transition={
        reducedMotion
          ? { duration: 0 }
          : {
              duration: REVEAL_DURATION_MS / 1000,
              delay: delayMs / 1000,
              ease: MotionEasing.outStrong,
            }
      }
    >
      {children}
    </motion.div>
  );
};

export default MountReveal;
